import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";

// window.location.hostname

const liveConfig = {
  apiKey: "AIzaSyCdpe55kocRkxtzOQk6t3-tjaaMGrrryUk",
  authDomain: "ti-coop.firebaseapp.com",
  projectId: "ti-coop",
  storageBucket: "ti-coop.appspot.com",
  messagingSenderId: "313587609825",
  appId: "1:313587609825:web:e0626d77f5774f1de447a0",
  measurementId: "G-GH3LQ2JPPT"
};

const devConfig = {...liveConfig};

// const devConfig = {
//   apiKey: "AIzaSyCK-M7UXEoq00AYlliNeQKPSiCcrMeqQ8A",
//   authDomain: "dev-ti-coop.firebaseapp.com",
//   projectId: "dev-ti-coop",
//   storageBucket: "dev-ti-coop.appspot.com",
//   messagingSenderId: "103501204516",
//   appId: "1:103501204516:web:aa6946ccdc8773239d1cb1",
//   measurementId: "G-J0EJVYK0YT"
// };

const localConfig = { ...devConfig };
const testConfig = { ...devConfig };

const environments = {
  live: liveConfig,
  test: testConfig,
  dev: devConfig,
  local: localConfig,
}

const getConfig = ({ hostname }) => {
  if (/^test/i.test(hostname)) return environments.test;
  else if (/^dev/i.test(hostname)) return environments.dev;
  else if (/^localhost/i.test(hostname)) return environments.local;
  else return environments.live;
}

const setPersistenceNone = () => {
  return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
}

const app = firebase.initializeApp(getConfig(window.location));
const fdb = firebase.firestore(app);
const auth = app.auth();
const storage = firebase.storage();

export default firebase;
export { fdb, auth, setPersistenceNone, storage };
